import { createSlice } from '@reduxjs/toolkit'
import { QRData } from '../../enums/QRData'

interface StepState {
  step: number
  data: string
}
const defaultState: StepState = {
  step: 0,
  data: QRData.NOT_SCANNED
}

const initialState: StepState = defaultState

const stepSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    setStep(state, action) {
      state.step = action.payload
    },
    setData(state, action) {
      state.data = action.payload
    },
    resetSteps() {
      return defaultState
    }
  }
})

export const { setStep, setData, resetSteps } = stepSlice.actions

export default stepSlice.reducer
